/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  GamoraControllerContextIdentifier,
  GamoraFoundationGlueListenerType,
  GamoraFoundationNodeArgs,
  debugCreate,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolChulakServiceStateEvent,
  HoruzProtocolChulakServiceStateInvoker,
} from './enums.js';
import { HoruzProtocolChulakServiceStateBase } from './base.js';
import { HoruzProtocolChulakServiceStateContext } from '../context.js';
import { HoruzProtocolChulakServiceStateMap } from '../../statemap.js';
import { IHoruz } from '../../../../horuz.js';
const debug = debugCreate({
  namespace: 'horuz:protocols:chulak:states:server:done',
});

/**
 * Service
 *
 * Stopped state
 * @public
 */
export class HoruzProtocolChulakServiceStateStopped extends HoruzProtocolChulakServiceStateBase<
  typeof HoruzProtocolChulakServiceStateMap,
  HoruzProtocolChulakServiceStateContext,
  IHoruz
> {
  constructor(args: GamoraFoundationNodeArgs) {
    super(args);
  }

  /**
   * Enter state
   */
  override async $enter(
    serviceStateContext: HoruzProtocolChulakServiceStateContext,
  ): Promise<void> {
    // Emit done handler
    await this.$emit(
      serviceStateContext.contextIdentifier,
      HoruzProtocolChulakServiceStateEvent.Stopped,
      serviceStateContext,
      {},
    );
  }

  /**
   * Exit state
   */
  override async $exit(
    serviceStateContext: HoruzProtocolChulakServiceStateContext,
  ): Promise<void> {}

  /**
   * Register invokers
   */
  on(
    contextIdentifier: GamoraControllerContextIdentifier,
    name: typeof HoruzProtocolChulakServiceStateEvent.Stopped,
    listener: (
      stateContext: HoruzProtocolChulakServiceStateContext,
    ) => Promise<void>,
  ): this;
  on<K extends keyof typeof HoruzProtocolChulakServiceStateInvoker>(
    contextIdentifier: GamoraControllerContextIdentifier,
    name: K,
    listener: GamoraFoundationGlueListenerType,
  ): this {
    return super.$on(contextIdentifier, name, listener);
  }
}
